import { css } from "@emotion/css"
import { useId } from "react"
import { Tooltip } from "react-tooltip"
import "react-tooltip/dist/react-tooltip.css"

import Skeleton from "@p-ban/common/src/components/Skeleton"
import Image from "@p-ban/common/src/components/html/Image"
import Spacer from "@p-ban/common/src/components/layout/Spacer"

import useUserQuery from "../../../../api/user/useUserQuery"
import SideBarLabel from "../components/SideBarLabel"

import diamondIcon from "./diamond.gif"
import goldIcon from "./gold.gif"
import platinaIcon from "./platina.gif"
import silverIcon from "./silver.gif"

const getImage = (level: string) => {
  switch (level) {
    case "シルバー":
      return silverIcon
    case "ゴールド":
      return goldIcon
    case "プラチナ":
      return platinaIcon
    case "ダイヤモンド":
      return diamondIcon
    default:
      return null
  }
}

const openDiscountDetail = () => {
  window.open(
    "/kiban/com/csComShwDiscountDetail.do",
    "ボリュームディスカウント詳細",
    "top=10,left=10,width=930,height=530,status=no,scrollbars=yes,directories=no,menubar=no,resizable=yes,toolbar=no"
  )
}

const VolumeDiscount = () => {
  const userInfo = useUserQuery()
  const isFetching = !userInfo

  const volumeDiscountIcon = getImage(userInfo?.currentVolumeDiscountUserLevel ?? "")

  const tooltipId = useId()

  return (
    <>
      <SideBarLabel>
        <Skeleton disabled={!isFetching}>
          <button id={tooltipId} className={styles.button} onClick={openDiscountDetail}>
            {volumeDiscountIcon ? (
              <>
                <Image src={volumeDiscountIcon} alt="" width={27} height={27} />
                <Spacer size={4} />
                {userInfo?.currentVolumeDiscountUserLevel}ユーザー
              </>
            ) : (
              "ボリュームディスカウント"
            )}
          </button>
        </Skeleton>
      </SideBarLabel>
      <Tooltip
        anchorId={tooltipId}
        place="right"
        className={css`
          color: #ffff00;
          z-index: 100;
        `}
        content={
          userInfo && userInfo.currentDiscountPercent !== 0
            ? `現在、見積登録すると、「${userInfo.currentDiscountPercent}%」割引のボリュームディスカウントが、基板製造サービス(※一部、対象外）に適用されます。`
            : undefined
        }
      />
    </>
  )
}

export default VolumeDiscount

const styles = {
  button: css`
    display: flex;
    align-items: center;
    text-decoration: underline;
    font: inherit;
    font-size: 12px;
    color: inherit;
    cursor: pointer;
    background-color: inherit;
    border: none;
  `,
}
